// eslint-disable-next-line import/prefer-default-export -- remove me when more constants are added
export const PAY_FILTER = {
    USER_IDS: 'ids',
    USER_GROUP: 'user_group',
    MEMBER_TYPE: 'milk_category',
    PAY_GROUP: 'pay_group',
    FEDERAL_ORDER: 'federal_order',
    STATE: 'state',
};
